<template>
  <div class="content multi-net-record-page">
    <!-- 搜索筛选区域 -->
    <div class="query-block">
      <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="0">
        <el-form-item prop="groupNo">
          <el-input v-model="queryParams.groupNo" placeholder="组网号" clearable class="wd-220"></el-input>
        </el-form-item>
        <el-form-item prop="iccid">
          <el-input v-model="queryParams.iccid" placeholder="卡号/批量卡号" clearable class="wd-220"></el-input>
        </el-form-item>
        <el-form-item prop="type">
          <el-select v-model="queryParams.type" placeholder="操作类型" clearable class="wd-160">
            <el-option value="1" label="组网"></el-option>
            <el-option value="2" label="拆网"></el-option>
            <el-option value="3" label="换卡"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="createTimeRange">
          <el-date-picker
            v-model="queryParams.createTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="操作时间起"
            end-placeholder="操作时间止"
            value-format="yyyy-MM-dd"
            class="wd-320">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      border
      v-loading="loading"
      ref="tableData"
      class="data-table"
      stripe
    >
      <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
      <el-table-column prop="groupNo" label="组网号" align="center" width="150">
        <template slot-scope="scope">
          <el-link v-if="scope.row.groupNo" type="primary" :underline="false" @click="goMultiNetDetail(scope.row.groupNo)">{{ scope.row.groupNo }}</el-link>
          <span v-else class="placeholder">--</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="操作类型" align="center" width="100">
        <template slot-scope="scope">
          <el-tag :type="getOperationTypeType(scope.row.type)">{{ getOperationTypeName(scope.row.type) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="变更后卡号" align="center" min-width="260">
        <template slot-scope="scope">
          <div class="multi-iccid">
            <div v-if="scope.row.ydIccid">移动：<el-link type="primary" :underline="false" @click="goCardDetail(scope.row.ydIccid)">{{ scope.row.ydIccid }}</el-link></div>
            <div v-if="scope.row.dxIccid">电信：<el-link type="primary" :underline="false" @click="goCardDetail(scope.row.dxIccid)">{{ scope.row.dxIccid }}</el-link></div>
            <span v-if="!scope.row.ydIccid && !scope.row.dxIccid" class="placeholder">--</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="变更前卡号" align="center" min-width="260">
        <template slot-scope="scope">
          <div class="multi-iccid">
            <div v-if="scope.row.beforeYdIccid">移动：<el-link type="primary" :underline="false" @click="goCardDetail(scope.row.beforeYdIccid)">{{ scope.row.beforeYdIccid }}</el-link></div>
            <div v-if="scope.row.beforeDxIccid">电信：<el-link type="primary" :underline="false" @click="goCardDetail(scope.row.beforeDxIccid)">{{ scope.row.beforeDxIccid }}</el-link></div>
            <span v-if="!scope.row.beforeYdIccid && !scope.row.beforeDxIccid" class="placeholder">--</span>
          </div>
        </template>
      </el-table-column>
      
      <el-table-column prop="createUser" label="操作人" align="center" width="120"></el-table-column>
      <el-table-column prop="createTime" label="操作时间" align="center" width="160"></el-table-column>
    </el-table>

    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="getList"
    />
  </div>
</template>

<script>
import { multiNetRecordPage } from '@/api/multiNet'

export default {
  name: 'MultiNetRecord',
  data() {
    return {
      loading: false,
      page: 1,
      pageSize: 20,
      total: 0,
      queryParams: {
        groupNo: '',
        iccid: '',
        type: '',
        createTimeRange: []
      },
      tableData: [],
      operationTypeOptions: [
        { id: '1', name: '组网', type: 'success' },
        { id: '2', name: '拆网', type: 'danger' },
        { id: '3', name: '换卡', type: 'warning' }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 查询
    handleQuery() {
      this.page = 1
      this.getList()
    },
    // 重置
    resetQuery() {
      this.$refs.queryForm.resetFields()
      this.queryParams.createTimeRange = []
      this.page = 1
      this.getList()
    },
    // 刷新表格
    refreshTable() {
      this.getList()
    },
    // 获取列表数据
    getList() {
      this.loading = true
      const params = {
        model: {
          ...this.addDateRange(this.queryParams, this.queryParams.createTimeRange)
        },
        pageNum: this.page,
        pageSize: this.pageSize
      }
      multiNetRecordPage(params).then(res => {
        this.loading = false
        if (res.data.code === 200) {
          this.tableData = res.data.data.records || []
          this.total = res.data.data.total || 0
        } else {
          this.$message.error(res.data.message || '获取组网记录失败')
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 跳转组网详情
    goMultiNetDetail(groupNo) {
      if (!groupNo) {
        this.$message.warning('组网号不存在')
        return
      }
      this.$router.push({ path: '/card/multiNet/info', query: { groupNo } })
    },
    // 跳转卡详情
    goCardDetail(iccid) {
      if (!iccid) return
      this.$router.push({ path: '/card/detail', query: { iccid } })
    },
    // 操作类型名称
    getOperationTypeName(type) {
      const opt = this.operationTypeOptions.find(o => o.id === String(type))
      return opt ? opt.name : (type || '--')
    },
    // 操作类型标签样式
    getOperationTypeType(type) {
      const opt = this.operationTypeOptions.find(o => o.id === String(type))
      return opt ? opt.type : 'info'
    }
  }
}
</script>

<style lang="scss" scoped>
.multi-net-record-page {
  .query-block {
    background: #fff;
    border-radius: 4px;
    margin-bottom: 16px;

    .el-form-item .el-button + .el-button {
      margin-left: 12px;
    }
  }

  .data-table {
    background: #fff;
    border-radius: 4px;
  }

  .multi-iccid {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    color: #606266;
    line-height: 1.6;
  }

  .placeholder {
    color: #c0c4cc;
  }

  .wd-160 { width: 160px; }
  .wd-220 { width: 220px; }
  .wd-320 { width: 320px; }
}
</style>
